import { render, staticRenderFns } from "./EditorElementInfoEventsAdd.vue?vue&type=template&id=48e7d638&lang=pug"
import script from "./EditorElementInfoEventsAdd.vue?vue&type=script&lang=js"
export * from "./EditorElementInfoEventsAdd.vue?vue&type=script&lang=js"
import style0 from "./EditorElementInfoEventsAdd.vue?vue&type=style&index=0&id=48e7d638&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports